import React, { useState, useEffect, lazy, Suspense } from 'react';
const Chart = lazy(() => import('react-apexcharts'));
const ApexUserAreaChart = ({ users, values, chartData }) => {
    
    const [data, setData] = useState({
        months: [],
        adminCounts: [],
        registerCounts: [],
        subscriberCounts: [],
    });

    useEffect(() => {

        if (!users || users.length === 0) {
            setData({
                months: [],
                adminCounts: [],
                registerCounts: [],
                subscriberCounts: [],
            });
            return;
        }

        const monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const adminCount = Array(12).fill(0);
        const registerCount = Array(12).fill(0);
        const subscriberCount = Array(12).fill(0);

        users.forEach(user => {
            const date = new Date(user.created_at);
            const monthIndex = date.getMonth();

            if (user.role === 'Admin') {
                adminCount[monthIndex]++;
            } else if (user.role === 'Register') {
                registerCount[monthIndex]++;
            } else if (user.role === 'Subscriber') {
                subscriberCount[monthIndex]++;
            }
        });

        setData({
            months: monthLabels,
            adminCounts: adminCount,
            registerCounts: registerCount,
            subscriberCounts: subscriberCount,
        });
    }, [users]);

    // useEffect(() => {
    //     const currentYear = new Date().getFullYear();
    //     const currentMonth = new Date().getMonth();
    //     const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    //     const dateArray = [];
    //     for (let day = 1; day <= daysInMonth; day++) {
    //         const formattedDay = String(day).padStart(2, '0');
    //         const formattedMonth = String(currentMonth + 1).padStart(2, '0');
    //         const dateString = `${currentYear}-${formattedMonth}-${formattedDay}`;
    //         dateArray.push(dateString);
    //     }
    //     setData((prev) => ({
    //         ...prev,
    //         dateArray: dateArray,
    //         start: values?.start,
    //         end: values?.end,
    //     }));
    //     const adminUsers = users.filter(user => user.role == "Admin");
    //     const registerUsers = users.filter(user => user.role == "Register");
    //     const subscriverUsers = users.filter(user => user?.role == "Subscriber");
    //     const adminCountByDate = dateArray.reduce((acc, date) => {
    //         acc[date] = 0;
    //         return acc;
    //     }, {});
    //     const registerCountByDate = dateArray.reduce((acc, date) => {
    //         acc[date] = 0;
    //         return acc;
    //     }, {});

    //     const subscriberCountByDate = dateArray.reduce((acc, date) => {
    //         acc[date] = 0;
    //         return acc;
    //     }, {});
    //     adminUsers.forEach(user => {
    //         const date = user.created_at.split('T')[0];
    //         if (adminCountByDate[date] !== undefined) {
    //             adminCountByDate[date] += 1;
    //         }
    //     });
    //     registerUsers.forEach(user => {
    //         const date = user.created_at.split('T')[0];
    //         if (registerCountByDate[date] !== undefined) {
    //             registerCountByDate[date] += 1;
    //         }
    //     });
    //     subscriverUsers.forEach(user => {
    //         const date = user.created_at.split('T')[0];
    //         if (subscriberCountByDate[date] !== undefined) {
    //             subscriberCountByDate[date] += 1;
    //         }
    //     });
    //     const adminCountArray = dateArray.map(date => {
    //         const formattedDate = date.replace(/-/g, "/");
    //         return [formattedDate, adminCountByDate[date]];
    //     });
    //     const registerCountArray = dateArray.map(date => {
    //         const formattedDate = date.replace(/-/g, "/");
    //         return [formattedDate, registerCountByDate[date]];
    //     });
    //     const subscriberCountArray = dateArray.map(date => {
    //         const formattedDate = date.replace(/-/g, "/");
    //         return [formattedDate, subscriberCountByDate[date]];
    //     });
    //     setData((prev) => ({
    //         ...prev,
    //         adminTotal: adminCountArray,
    //         registerTotal: registerCountArray,
    //         subscriberTotal: subscriberCountArray,
    //     }));
    // }, [users, values])
    // console.log(data, 'setData')
    const categories = data?.dateArray?.map(date => date.replace(/-/g, '/')) || [];
    const adminCounts = data?.adminTotal?.map(([_, y]) => y) || [];
    const registerCounts = data?.registerTotal?.map(([_, y]) => y) || [];
    const subscriberCounts = data?.subscriberTotal?.map(([_, y]) => y) || [];

    const chartSeries = [
        {
            name: 'Admin',
            data: data.adminCounts,
        },
        {
            name: 'Register',
            data: data.registerCounts,
        },
        {
            name: 'Subscriber',
            data: data.subscriberCounts,
        },
    ];
    const options = {
        chart: {
            type: 'area',
            height: 350,
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: ['#00E396', '#008FFB', '#FEB019'], // Green, Blue, Orange
        stroke: {
            curve: 'smooth',
            width: 3,
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.05,
                stops: [0, 90, 100],
            },
        },
        markers: {
            size: 4,
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: data.months,
            title: {
                text: 'Month',
                style: { fontWeight: 600 },
            },
        },
        yaxis: {
            title: {
                text: 'User Count',
                style: { fontWeight: 600 },
            },
        },
        tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            fontWeight: 500,
        },
    };

    return (
        <div id="chart" className="theme-bg-color rounded-3 p-3">
            <Suspense fallback={<div className="text-center py-4">Loading Chart...</div>}>
                <Chart
                    options={options}
                    series={chartSeries}
                    type="area"
                    height={350}
                />
            </Suspense>
        </div>
    );
};

export default ApexUserAreaChart;
